__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@monorepo/privacy-portal";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@monorepo/input-card", "1.0.0", () => (Promise.all([__webpack_require__.e(7029), __webpack_require__.e(3572), __webpack_require__.e(2348), __webpack_require__.e(7359), __webpack_require__.e(1852), __webpack_require__.e(7155)]).then(() => (() => (__webpack_require__(7155))))));
			register("@monorepo/localization", "1.0.4", () => (Promise.all([__webpack_require__.e(74), __webpack_require__.e(7359), __webpack_require__.e(4267)]).then(() => (() => (__webpack_require__(9057))))));
			register("@monorepo/maintenance", "1.0.0", () => (Promise.all([__webpack_require__.e(3572), __webpack_require__.e(7359), __webpack_require__.e(6923)]).then(() => (() => (__webpack_require__(6923))))));
			register("@monorepo/modal", "1.0.0", () => (Promise.all([__webpack_require__.e(7029), __webpack_require__.e(3572), __webpack_require__.e(7710), __webpack_require__.e(7359), __webpack_require__.e(6551), __webpack_require__.e(3100)]).then(() => (() => (__webpack_require__(3100))))));
			register("@monorepo/store/usePreferencesStore", "1.0.0", () => (Promise.all([__webpack_require__.e(7710), __webpack_require__.e(602)]).then(() => (() => (__webpack_require__(602))))));
			register("@monorepo/store/useUserStore", "1.0.0", () => (Promise.all([__webpack_require__.e(7710), __webpack_require__.e(6272)]).then(() => (() => (__webpack_require__(6272))))));
			register("@monorepo/subpage-wrapper", "1.0.0", () => (Promise.all([__webpack_require__.e(3572), __webpack_require__.e(2348), __webpack_require__.e(7359), __webpack_require__.e(1852), __webpack_require__.e(8533), __webpack_require__.e(81)]).then(() => (() => (__webpack_require__(81))))));
			register("@monorepo/theme-provider", "1.0.0", () => (Promise.all([__webpack_require__.e(3572), __webpack_require__.e(7359), __webpack_require__.e(9005)]).then(() => (() => (__webpack_require__(9005))))));
			register("@tanstack/react-query", "5.75.2", () => (Promise.all([__webpack_require__.e(769), __webpack_require__.e(7359), __webpack_require__.e(5723)]).then(() => (() => (__webpack_require__(769))))));
			register("@unleash/proxy-client-react", "4.5.2", () => (Promise.all([__webpack_require__.e(7359), __webpack_require__.e(5074), __webpack_require__.e(6963)]).then(() => (() => (__webpack_require__(6963))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(316), __webpack_require__.e(7359)]).then(() => (() => (__webpack_require__(316))))));
			register("react-router-dom", "6.30.0", () => (Promise.all([__webpack_require__.e(1928), __webpack_require__.e(7359), __webpack_require__.e(8991)]).then(() => (() => (__webpack_require__(1928))))));
			register("react", "18.3.1", () => (__webpack_require__.e(2155).then(() => (() => (__webpack_require__(2155))))));
			register("unleash-proxy-client", "3.7.6", () => (__webpack_require__.e(3400).then(() => (() => (__webpack_require__(3400))))));
			register("zustand", "4.5.6", () => (Promise.all([__webpack_require__.e(7359), __webpack_require__.e(6084)]).then(() => (() => (__webpack_require__(6084))))));
			initExternal(4844);
			initExternal(9279);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};